import { getIn } from "@utils/index"
import * as R from "ramda"
import React from "react"

const transformData = (data) => {
  const transformedData: any = {
    allContentfulPrintedDesign: getIn(data, "allContentfulPrintedDesign", {
      nodes: [],
    }),
    contentfulDevice: getIn(data, "contentfulDevice"),
    contentfulGlobalSettings: getIn(data, "contentfulGlobalSettings"),
  }

  const contentfulProducts = getIn(data, "productsWithOneDevice.nodes", [])
  const productsWithManyDevices = getIn(
    data,
    "productsWithManyDevices.nodes",
    []
  )
  let contentfulProductsToMerge: any = []

  if (productsWithManyDevices.length > 0) {
    contentfulProductsToMerge = []
    productsWithManyDevices.forEach((p) => {
      if (p.devices && p.devices.length > 0) {
        p.devices.forEach((device) => {
          const thisProduct = { ...p }
          thisProduct.device = device
          contentfulProductsToMerge.push(thisProduct)
        })
      }
    })
  }

  transformedData.allContentfulProduct = {
    nodes: R.uniqBy((p: any) => {
      return p.slug
    })([...contentfulProducts, ...contentfulProductsToMerge]),
  }

  return transformedData
}

interface PropsWithData {
  data: any
}

export default function <A extends PropsWithData>(
  WrappedComponent: React.ComponentType<A>
) {
  return (props: A) => (
    <WrappedComponent {...props} data={transformData(props.data)} />
  )
}
